// layouts/ScrollableLayout.tsx
import React, { ReactNode } from 'react';
import BaseLayout from './BaseLayout';

interface ScrollableLayoutProps {
    children: ReactNode;
    className?: string;
    requireAuth?: boolean;
}

export const ScrollableLayout: React.FC<ScrollableLayoutProps> = ({
                                                                      children,
                                                                      className,
                                                                      requireAuth = true
                                                                  }) => {
    return (
        <BaseLayout
            variant="scrollable"
            className={className}
            requireAuth={requireAuth}
        >
            {children}
        </BaseLayout>
    );
};